module.exports = __webpack_public_path__ + "media/诚信计量-操作说明v1.8c065fa2.mp4";